function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 13.952C23.369 13.952 22.3538 15.0226 22.0501 15.5579C21.7494 16.0704 22.6173 17.3962 24.9476 17.3962C27.2779 17.3962 27.7973 16.8768 27.934 16.3028C28.0706 15.7288 27.0388 13.952 25 13.952Z",
  fill: "url(#paint0_linear_18_3868)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25 13.952C23.369 13.952 22.3538 15.0226 22.0501 15.5579C21.7494 16.0704 22.6173 17.3962 24.9476 17.3962C27.2779 17.3962 27.7973 16.8768 27.934 16.3028C28.0706 15.7288 27.0388 13.952 25 13.952Z",
  fill: "url(#paint1_radial_18_3868)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25 13.952C23.369 13.952 22.3538 15.0226 22.0501 15.5579C21.7494 16.0704 22.6173 17.3962 24.9476 17.3962C27.2779 17.3962 27.7973 16.8768 27.934 16.3028C28.0706 15.7288 27.0388 13.952 25 13.952Z",
  fill: "url(#paint2_radial_18_3868)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5106 17.4308C28.5106 16.1653 27.3008 15.0254 25.8984 15.0254C24.5625 15.0254 23.2908 15.8612 23.2908 17.605C23.2908 19.3487 24.4754 19.7166 26.4252 19.7166C28.3749 19.7166 28.5106 18.6963 28.5106 17.4308Z",
  fill: "url(#paint3_linear_18_3868)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5106 17.4308C28.5106 16.1653 27.3008 15.0254 25.8984 15.0254C24.5625 15.0254 23.2908 15.8612 23.2908 17.605C23.2908 19.3487 24.4754 19.7166 26.4252 19.7166C28.3749 19.7166 28.5106 18.6963 28.5106 17.4308Z",
  fill: "url(#paint4_radial_18_3868)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5106 17.4308C28.5106 16.1653 27.3008 15.0254 25.8984 15.0254C24.5625 15.0254 23.2908 15.8612 23.2908 17.605C23.2908 19.3487 24.4754 19.7166 26.4252 19.7166C28.3749 19.7166 28.5106 18.6963 28.5106 17.4308Z",
  fill: "url(#paint5_radial_18_3868)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M28.4302 18.9863C28.4302 17.3179 26.9346 16.5124 25.8861 16.5124C24.752 16.5124 23.9433 17.2014 23.6807 17.5459C24.039 18.6645 24.844 21.1814 25.197 22.3001C25.6383 23.6983 26.1541 23.9966 26.6264 24.2887C27.0987 24.5808 27.3846 24.3509 27.3846 23.9407V23.2757C27.3846 21.5667 28.4302 21.3617 28.4302 18.9863Z",
  fill: "#45A6FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4302 18.9863C28.4302 17.3179 26.9346 16.5124 25.8861 16.5124C24.752 16.5124 23.9433 17.2014 23.6807 17.5459C24.039 18.6645 24.844 21.1814 25.197 22.3001C25.6383 23.6983 26.1541 23.9966 26.6264 24.2887C27.0987 24.5808 27.3846 24.3509 27.3846 23.9407V23.2757C27.3846 21.5667 28.4302 21.3617 28.4302 18.9863Z",
  fill: "url(#paint6_radial_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4302 18.9863C28.4302 17.3179 26.9346 16.5124 25.8861 16.5124C24.752 16.5124 23.9433 17.2014 23.6807 17.5459C24.039 18.6645 24.844 21.1814 25.197 22.3001C25.6383 23.6983 26.1541 23.9966 26.6264 24.2887C27.0987 24.5808 27.3846 24.3509 27.3846 23.9407V23.2757C27.3846 21.5667 28.4302 21.3617 28.4302 18.9863Z",
  fill: "url(#paint7_radial_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.4302 18.9863C28.4302 17.3179 26.9346 16.5124 25.8861 16.5124C24.752 16.5124 23.9433 17.2014 23.6807 17.5459C24.039 18.6645 24.844 21.1814 25.197 22.3001C25.6383 23.6983 26.1541 23.9966 26.6264 24.2887C27.0987 24.5808 27.3846 24.3509 27.3846 23.9407V23.2757C27.3846 21.5667 28.4302 21.3617 28.4302 18.9863Z",
  fill: "url(#paint8_radial_18_3868)"
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 20.8974,
  width: 5,
  height: 9.01344,
  rx: 1.1,
  fill: "#2B1E54"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 20.8974,
  width: 5,
  height: 9.01344,
  rx: 1.1,
  fill: "url(#paint9_radial_18_3868)"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 20.8974,
  width: 5,
  height: 9.01344,
  rx: 1.1,
  fill: "url(#paint10_radial_18_3868)"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 20.8974,
  width: 5,
  height: 9.01344,
  rx: 1.1,
  fill: "url(#paint11_linear_18_3868)"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 18.4981,
  y: 21.868,
  width: 5,
  height: 8.04278,
  rx: 1.1,
  fill: "#2B1E54"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 18.4981,
  y: 21.868,
  width: 5,
  height: 8.04278,
  rx: 1.1,
  fill: "url(#paint12_radial_18_3868)"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 18.4981,
  y: 21.868,
  width: 5,
  height: 8.04278,
  rx: 1.1,
  fill: "url(#paint13_linear_18_3868)"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 18.4981,
  y: 21.868,
  width: 5,
  height: 8.04278,
  rx: 1.1,
  fill: "url(#paint14_radial_18_3868)"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_i_18_3868)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 2.07399,
  width: 2.57088,
  height: 3.97809,
  rx: 1,
  fill: "#54892F"
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 2.07399,
  width: 2.57088,
  height: 3.97809,
  rx: 1,
  fill: "url(#paint15_radial_18_3868)"
}), /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 2.07399,
  width: 2.57088,
  height: 3.97809,
  rx: 1,
  fill: "url(#paint16_radial_18_3868)"
}));

var _ref18 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_ii_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.06646 6.75567C7.93599 6.70194 7.84376 6.55273 8.00001 6.49472C8.12793 6.4165 8.19434 6.31116 8.27092 6.14712C8.35214 5.97317 8.4448 5.73319 8.6344 5.38954C9.00279 4.72182 9.66283 4.49158 10.2691 4.49158H11.4511C11.7581 4.49158 12.0804 4.34575 12.0804 3.98632V3.11777C12.0804 2.34261 12.61 2.07399 13 2.07399H13.6461C14.1066 2.07399 14.4903 2.45773 14.4903 3.11777V5.50466C14.4903 6.11097 14.5441 6.30284 14.6438 6.49472C14.7436 6.68659 14.9508 6.93986 14.6438 6.93986C14.3368 6.93986 14.0404 6.60103 13.8945 6.46289C13.7487 6.32474 13.6998 6.32587 13.531 6.49472C13.3621 6.66357 13.0782 6.88614 12.7021 6.88614C12.326 6.88614 12.0881 6.69426 11.9346 6.49472C11.7811 6.29517 11.6524 6.26757 11.4511 6.49472C11.2747 6.69378 11.0366 6.88614 10.6452 6.88614C10.3321 6.88614 9.96912 6.5543 9.84376 6.42382C9.69794 6.278 9.59776 6.31727 9.48829 6.44726C8.8743 7.17637 8.19693 6.80939 8.06646 6.75567Z",
  fill: "url(#paint17_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.06646 6.75567C7.93599 6.70194 7.84376 6.55273 8.00001 6.49472C8.12793 6.4165 8.19434 6.31116 8.27092 6.14712C8.35214 5.97317 8.4448 5.73319 8.6344 5.38954C9.00279 4.72182 9.66283 4.49158 10.2691 4.49158H11.4511C11.7581 4.49158 12.0804 4.34575 12.0804 3.98632V3.11777C12.0804 2.34261 12.61 2.07399 13 2.07399H13.6461C14.1066 2.07399 14.4903 2.45773 14.4903 3.11777V5.50466C14.4903 6.11097 14.5441 6.30284 14.6438 6.49472C14.7436 6.68659 14.9508 6.93986 14.6438 6.93986C14.3368 6.93986 14.0404 6.60103 13.8945 6.46289C13.7487 6.32474 13.6998 6.32587 13.531 6.49472C13.3621 6.66357 13.0782 6.88614 12.7021 6.88614C12.326 6.88614 12.0881 6.69426 11.9346 6.49472C11.7811 6.29517 11.6524 6.26757 11.4511 6.49472C11.2747 6.69378 11.0366 6.88614 10.6452 6.88614C10.3321 6.88614 9.96912 6.5543 9.84376 6.42382C9.69794 6.278 9.59776 6.31727 9.48829 6.44726C8.8743 7.17637 8.19693 6.80939 8.06646 6.75567Z",
  fill: "url(#paint18_radial_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.06646 6.75567C7.93599 6.70194 7.84376 6.55273 8.00001 6.49472C8.12793 6.4165 8.19434 6.31116 8.27092 6.14712C8.35214 5.97317 8.4448 5.73319 8.6344 5.38954C9.00279 4.72182 9.66283 4.49158 10.2691 4.49158H11.4511C11.7581 4.49158 12.0804 4.34575 12.0804 3.98632V3.11777C12.0804 2.34261 12.61 2.07399 13 2.07399H13.6461C14.1066 2.07399 14.4903 2.45773 14.4903 3.11777V5.50466C14.4903 6.11097 14.5441 6.30284 14.6438 6.49472C14.7436 6.68659 14.9508 6.93986 14.6438 6.93986C14.3368 6.93986 14.0404 6.60103 13.8945 6.46289C13.7487 6.32474 13.6998 6.32587 13.531 6.49472C13.3621 6.66357 13.0782 6.88614 12.7021 6.88614C12.326 6.88614 12.0881 6.69426 11.9346 6.49472C11.7811 6.29517 11.6524 6.26757 11.4511 6.49472C11.2747 6.69378 11.0366 6.88614 10.6452 6.88614C10.3321 6.88614 9.96912 6.5543 9.84376 6.42382C9.69794 6.278 9.59776 6.31727 9.48829 6.44726C8.8743 7.17637 8.19693 6.80939 8.06646 6.75567Z",
  fill: "url(#paint19_radial_18_3868)"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_ii_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.05007 6.74835C8.05545 6.75096 8.06092 6.75342 8.06646 6.7557C8.07449 6.759 8.08458 6.76349 8.09661 6.76884C8.28005 6.85043 8.91208 7.13154 9.48829 6.44729C9.59776 6.3173 9.69794 6.27803 9.84376 6.42385C9.96912 6.55433 10.3321 6.88617 10.6452 6.88617C11.0366 6.88617 11.2747 6.69381 11.4511 6.49475C11.6524 6.2676 11.7811 6.2952 11.9346 6.49475C12.0881 6.69429 12.326 6.88617 12.7021 6.88617C13.0782 6.88617 13.3621 6.6636 13.531 6.49475C13.6998 6.3259 13.7487 6.32477 13.8945 6.46292C13.9132 6.48058 13.9343 6.50152 13.9576 6.52462C14.0755 6.64165 14.2492 6.81394 14.4404 6.89483C14.4968 6.99889 14.5 7.08612 14.5 7.2313V9.81448C14.5 10.2754 14.5781 10.5567 14.6367 10.6621L14.6377 10.664C14.6965 10.7698 14.7995 10.9551 14.5781 10.9551C14.3555 10.9551 14.0273 10.6856 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4855 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9023 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85547 10.4707C9.73633 10.3516 9.65625 10.3262 9.52735 10.4475C9.50634 10.4673 9.48244 10.4936 9.455 10.5238C9.31405 10.679 9.07997 10.9366 8.66797 10.9366C8.22194 10.9366 7.96839 10.6182 7.8608 10.4831C7.84966 10.4691 7.84009 10.457 7.83203 10.4475C7.82371 10.4377 7.81554 10.4276 7.80742 10.4176C7.73164 10.3239 7.66028 10.2356 7.51563 10.4475C7.35547 10.6822 7.03906 10.9366 6.63051 10.9366C6.18652 10.9366 6.0127 10.7032 5.8841 10.5305C5.86175 10.5005 5.84077 10.4723 5.81997 10.4475C5.70224 10.3072 5.60262 10.3117 5.49847 10.4475C5.21773 10.8098 4.94151 10.9004 4.66529 10.9864C4.38907 11.0723 4.29398 10.9909 4.20342 10.769C4.15015 10.6238 4.08296 10.4956 4.0131 10.3624C3.82168 9.9974 3.61023 9.59418 3.61023 8.69515C3.61023 7.11029 4.66076 6.902 5.09094 6.902H7.12408C7.53257 6.902 7.7969 6.85154 8.05007 6.74835Z",
  fill: "url(#paint20_linear_18_3868)"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.05007 6.74835C8.05545 6.75096 8.06092 6.75342 8.06646 6.7557C8.07449 6.759 8.08458 6.76349 8.09661 6.76884C8.28005 6.85043 8.91208 7.13154 9.48829 6.44729C9.59776 6.3173 9.69794 6.27803 9.84376 6.42385C9.96912 6.55433 10.3321 6.88617 10.6452 6.88617C11.0366 6.88617 11.2747 6.69381 11.4511 6.49475C11.6524 6.2676 11.7811 6.2952 11.9346 6.49475C12.0881 6.69429 12.326 6.88617 12.7021 6.88617C13.0782 6.88617 13.3621 6.6636 13.531 6.49475C13.6998 6.3259 13.7487 6.32477 13.8945 6.46292C13.9132 6.48058 13.9343 6.50152 13.9576 6.52462C14.0755 6.64165 14.2492 6.81394 14.4404 6.89483C14.4968 6.99889 14.5 7.08612 14.5 7.2313V9.81448C14.5 10.2754 14.5781 10.5567 14.6367 10.6621L14.6377 10.664C14.6965 10.7698 14.7995 10.9551 14.5781 10.9551C14.3555 10.9551 14.0273 10.6856 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4855 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9023 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85547 10.4707C9.73633 10.3516 9.65625 10.3262 9.52735 10.4475C9.50634 10.4673 9.48244 10.4936 9.455 10.5238C9.31405 10.679 9.07997 10.9366 8.66797 10.9366C8.22194 10.9366 7.96839 10.6182 7.8608 10.4831C7.84966 10.4691 7.84009 10.457 7.83203 10.4475C7.82371 10.4377 7.81554 10.4276 7.80742 10.4176C7.73164 10.3239 7.66028 10.2356 7.51563 10.4475C7.35547 10.6822 7.03906 10.9366 6.63051 10.9366C6.18652 10.9366 6.0127 10.7032 5.8841 10.5305C5.86175 10.5005 5.84077 10.4723 5.81997 10.4475C5.70224 10.3072 5.60262 10.3117 5.49847 10.4475C5.21773 10.8098 4.94151 10.9004 4.66529 10.9864C4.38907 11.0723 4.29398 10.9909 4.20342 10.769C4.15015 10.6238 4.08296 10.4956 4.0131 10.3624C3.82168 9.9974 3.61023 9.59418 3.61023 8.69515C3.61023 7.11029 4.66076 6.902 5.09094 6.902H7.12408C7.53257 6.902 7.7969 6.85154 8.05007 6.74835Z",
  fill: "url(#paint21_linear_18_3868)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.05007 6.74835C8.05545 6.75096 8.06092 6.75342 8.06646 6.7557C8.07449 6.759 8.08458 6.76349 8.09661 6.76884C8.28005 6.85043 8.91208 7.13154 9.48829 6.44729C9.59776 6.3173 9.69794 6.27803 9.84376 6.42385C9.96912 6.55433 10.3321 6.88617 10.6452 6.88617C11.0366 6.88617 11.2747 6.69381 11.4511 6.49475C11.6524 6.2676 11.7811 6.2952 11.9346 6.49475C12.0881 6.69429 12.326 6.88617 12.7021 6.88617C13.0782 6.88617 13.3621 6.6636 13.531 6.49475C13.6998 6.3259 13.7487 6.32477 13.8945 6.46292C13.9132 6.48058 13.9343 6.50152 13.9576 6.52462C14.0755 6.64165 14.2492 6.81394 14.4404 6.89483C14.4968 6.99889 14.5 7.08612 14.5 7.2313V9.81448C14.5 10.2754 14.5781 10.5567 14.6367 10.6621L14.6377 10.664C14.6965 10.7698 14.7995 10.9551 14.5781 10.9551C14.3555 10.9551 14.0273 10.6856 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4855 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9023 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85547 10.4707C9.73633 10.3516 9.65625 10.3262 9.52735 10.4475C9.50634 10.4673 9.48244 10.4936 9.455 10.5238C9.31405 10.679 9.07997 10.9366 8.66797 10.9366C8.22194 10.9366 7.96839 10.6182 7.8608 10.4831C7.84966 10.4691 7.84009 10.457 7.83203 10.4475C7.82371 10.4377 7.81554 10.4276 7.80742 10.4176C7.73164 10.3239 7.66028 10.2356 7.51563 10.4475C7.35547 10.6822 7.03906 10.9366 6.63051 10.9366C6.18652 10.9366 6.0127 10.7032 5.8841 10.5305C5.86175 10.5005 5.84077 10.4723 5.81997 10.4475C5.70224 10.3072 5.60262 10.3117 5.49847 10.4475C5.21773 10.8098 4.94151 10.9004 4.66529 10.9864C4.38907 11.0723 4.29398 10.9909 4.20342 10.769C4.15015 10.6238 4.08296 10.4956 4.0131 10.3624C3.82168 9.9974 3.61023 9.59418 3.61023 8.69515C3.61023 7.11029 4.66076 6.902 5.09094 6.902H7.12408C7.53257 6.902 7.7969 6.85154 8.05007 6.74835Z",
  fill: "url(#paint22_radial_18_3868)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.05007 6.74835C8.05545 6.75096 8.06092 6.75342 8.06646 6.7557C8.07449 6.759 8.08458 6.76349 8.09661 6.76884C8.28005 6.85043 8.91208 7.13154 9.48829 6.44729C9.59776 6.3173 9.69794 6.27803 9.84376 6.42385C9.96912 6.55433 10.3321 6.88617 10.6452 6.88617C11.0366 6.88617 11.2747 6.69381 11.4511 6.49475C11.6524 6.2676 11.7811 6.2952 11.9346 6.49475C12.0881 6.69429 12.326 6.88617 12.7021 6.88617C13.0782 6.88617 13.3621 6.6636 13.531 6.49475C13.6998 6.3259 13.7487 6.32477 13.8945 6.46292C13.9132 6.48058 13.9343 6.50152 13.9576 6.52462C14.0755 6.64165 14.2492 6.81394 14.4404 6.89483C14.4968 6.99889 14.5 7.08612 14.5 7.2313V9.81448C14.5 10.2754 14.5781 10.5567 14.6367 10.6621L14.6377 10.664C14.6965 10.7698 14.7995 10.9551 14.5781 10.9551C14.3555 10.9551 14.0273 10.6856 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4855 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9023 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85547 10.4707C9.73633 10.3516 9.65625 10.3262 9.52735 10.4475C9.50634 10.4673 9.48244 10.4936 9.455 10.5238C9.31405 10.679 9.07997 10.9366 8.66797 10.9366C8.22194 10.9366 7.96839 10.6182 7.8608 10.4831C7.84966 10.4691 7.84009 10.457 7.83203 10.4475C7.82371 10.4377 7.81554 10.4276 7.80742 10.4176C7.73164 10.3239 7.66028 10.2356 7.51563 10.4475C7.35547 10.6822 7.03906 10.9366 6.63051 10.9366C6.18652 10.9366 6.0127 10.7032 5.8841 10.5305C5.86175 10.5005 5.84077 10.4723 5.81997 10.4475C5.70224 10.3072 5.60262 10.3117 5.49847 10.4475C5.21773 10.8098 4.94151 10.9004 4.66529 10.9864C4.38907 11.0723 4.29398 10.9909 4.20342 10.769C4.15015 10.6238 4.08296 10.4956 4.0131 10.3624C3.82168 9.9974 3.61023 9.59418 3.61023 8.69515C3.61023 7.11029 4.66076 6.902 5.09094 6.902H7.12408C7.53257 6.902 7.7969 6.85154 8.05007 6.74835Z",
  fill: "url(#paint23_radial_18_3868)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.05007 6.74835C8.05545 6.75096 8.06092 6.75342 8.06646 6.7557C8.07449 6.759 8.08458 6.76349 8.09661 6.76884C8.28005 6.85043 8.91208 7.13154 9.48829 6.44729C9.59776 6.3173 9.69794 6.27803 9.84376 6.42385C9.96912 6.55433 10.3321 6.88617 10.6452 6.88617C11.0366 6.88617 11.2747 6.69381 11.4511 6.49475C11.6524 6.2676 11.7811 6.2952 11.9346 6.49475C12.0881 6.69429 12.326 6.88617 12.7021 6.88617C13.0782 6.88617 13.3621 6.6636 13.531 6.49475C13.6998 6.3259 13.7487 6.32477 13.8945 6.46292C13.9132 6.48058 13.9343 6.50152 13.9576 6.52462C14.0755 6.64165 14.2492 6.81394 14.4404 6.89483C14.4968 6.99889 14.5 7.08612 14.5 7.2313V9.81448C14.5 10.2754 14.5781 10.5567 14.6367 10.6621L14.6377 10.664C14.6965 10.7698 14.7995 10.9551 14.5781 10.9551C14.3555 10.9551 14.0273 10.6856 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4855 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9023 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85547 10.4707C9.73633 10.3516 9.65625 10.3262 9.52735 10.4475C9.50634 10.4673 9.48244 10.4936 9.455 10.5238C9.31405 10.679 9.07997 10.9366 8.66797 10.9366C8.22194 10.9366 7.96839 10.6182 7.8608 10.4831C7.84966 10.4691 7.84009 10.457 7.83203 10.4475C7.82371 10.4377 7.81554 10.4276 7.80742 10.4176C7.73164 10.3239 7.66028 10.2356 7.51563 10.4475C7.35547 10.6822 7.03906 10.9366 6.63051 10.9366C6.18652 10.9366 6.0127 10.7032 5.8841 10.5305C5.86175 10.5005 5.84077 10.4723 5.81997 10.4475C5.70224 10.3072 5.60262 10.3117 5.49847 10.4475C5.21773 10.8098 4.94151 10.9004 4.66529 10.9864C4.38907 11.0723 4.29398 10.9909 4.20342 10.769C4.15015 10.6238 4.08296 10.4956 4.0131 10.3624C3.82168 9.9974 3.61023 9.59418 3.61023 8.69515C3.61023 7.11029 4.66076 6.902 5.09094 6.902H7.12408C7.53257 6.902 7.7969 6.85154 8.05007 6.74835Z",
  fill: "url(#paint24_radial_18_3868)"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_ii_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.73275 10.9651C4.70221 11.0062 4.76656 11.0733 4.8868 11.147C4.90225 11.1564 4.92046 11.1685 4.9418 11.1825C5.11642 11.2977 5.50009 11.5509 6.28712 11.6732C7.17032 11.8105 7.19778 12.227 7.15202 12.7349C7.14162 12.8503 7.12344 12.9935 7.10362 13.1496C7.03622 13.6805 6.95002 14.3594 7.08795 14.5928C7.2321 14.8368 7.34341 14.6598 7.41464 14.5466C7.43161 14.5196 7.4463 14.4962 7.45862 14.483C7.52269 14.4144 7.64167 14.3274 7.83387 14.5288C8.02607 14.7301 8.31437 14.9589 8.66674 14.9589C9.01911 14.9589 9.33029 14.7118 9.52249 14.483C9.67854 14.2972 9.74409 14.3709 9.82691 14.464C9.84609 14.4855 9.8662 14.5081 9.88858 14.5288C9.90235 14.5415 9.91789 14.5567 9.93523 14.5737C10.0678 14.7035 10.3053 14.9361 10.6574 14.9361C11.0555 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.7419 14.3595 11.8563 14.483L11.8591 14.4861C12.0823 14.732 12.2882 14.9589 12.6938 14.9589C13.1011 14.9589 13.307 14.7393 13.5312 14.483C13.652 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.9269 14.5282 13.9486 14.5507C14.1544 14.7639 14.3428 14.9589 14.7422 14.9589C15.163 14.9589 15.4134 14.7313 15.5442 14.6124C15.5506 14.6065 15.5567 14.601 15.5625 14.5957C15.6875 14.483 15.7461 14.416 15.5625 14.2832C15.5478 14.2726 15.5286 14.2601 15.5058 14.2452C15.2446 14.0753 14.5078 13.5958 14.5078 11.9863V11.252C14.5078 11.0523 14.4896 10.9984 14.4152 10.9183C14.2177 10.8386 13.9975 10.646 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4856 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9024 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85548 10.4707C9.73634 10.3516 9.65626 10.3262 9.52736 10.4475C9.50635 10.4673 9.48245 10.4936 9.45502 10.5238L9.45501 10.5238C9.31406 10.6789 9.07998 10.9366 8.66798 10.9366C8.22195 10.9366 7.9684 10.6182 7.86081 10.483C7.84967 10.4691 7.8401 10.457 7.83204 10.4475C7.82372 10.4377 7.81555 10.4276 7.80743 10.4176C7.73165 10.3239 7.66029 10.2356 7.51564 10.4475C7.35548 10.6822 7.03907 10.9366 6.63052 10.9366C6.18653 10.9366 6.01271 10.7032 5.88411 10.5305C5.86176 10.5005 5.84078 10.4723 5.81998 10.4475C5.70225 10.3072 5.60263 10.3117 5.49848 10.4475C5.24059 10.7803 4.98651 10.8838 4.73275 10.9651Z",
  fill: "url(#paint25_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.73275 10.9651C4.70221 11.0062 4.76656 11.0733 4.8868 11.147C4.90225 11.1564 4.92046 11.1685 4.9418 11.1825C5.11642 11.2977 5.50009 11.5509 6.28712 11.6732C7.17032 11.8105 7.19778 12.227 7.15202 12.7349C7.14162 12.8503 7.12344 12.9935 7.10362 13.1496C7.03622 13.6805 6.95002 14.3594 7.08795 14.5928C7.2321 14.8368 7.34341 14.6598 7.41464 14.5466C7.43161 14.5196 7.4463 14.4962 7.45862 14.483C7.52269 14.4144 7.64167 14.3274 7.83387 14.5288C8.02607 14.7301 8.31437 14.9589 8.66674 14.9589C9.01911 14.9589 9.33029 14.7118 9.52249 14.483C9.67854 14.2972 9.74409 14.3709 9.82691 14.464C9.84609 14.4855 9.8662 14.5081 9.88858 14.5288C9.90235 14.5415 9.91789 14.5567 9.93523 14.5737C10.0678 14.7035 10.3053 14.9361 10.6574 14.9361C11.0555 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.7419 14.3595 11.8563 14.483L11.8591 14.4861C12.0823 14.732 12.2882 14.9589 12.6938 14.9589C13.1011 14.9589 13.307 14.7393 13.5312 14.483C13.652 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.9269 14.5282 13.9486 14.5507C14.1544 14.7639 14.3428 14.9589 14.7422 14.9589C15.163 14.9589 15.4134 14.7313 15.5442 14.6124C15.5506 14.6065 15.5567 14.601 15.5625 14.5957C15.6875 14.483 15.7461 14.416 15.5625 14.2832C15.5478 14.2726 15.5286 14.2601 15.5058 14.2452C15.2446 14.0753 14.5078 13.5958 14.5078 11.9863V11.252C14.5078 11.0523 14.4896 10.9984 14.4152 10.9183C14.2177 10.8386 13.9975 10.646 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4856 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9024 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85548 10.4707C9.73634 10.3516 9.65626 10.3262 9.52736 10.4475C9.50635 10.4673 9.48245 10.4936 9.45502 10.5238L9.45501 10.5238C9.31406 10.6789 9.07998 10.9366 8.66798 10.9366C8.22195 10.9366 7.9684 10.6182 7.86081 10.483C7.84967 10.4691 7.8401 10.457 7.83204 10.4475C7.82372 10.4377 7.81555 10.4276 7.80743 10.4176C7.73165 10.3239 7.66029 10.2356 7.51564 10.4475C7.35548 10.6822 7.03907 10.9366 6.63052 10.9366C6.18653 10.9366 6.01271 10.7032 5.88411 10.5305C5.86176 10.5005 5.84078 10.4723 5.81998 10.4475C5.70225 10.3072 5.60263 10.3117 5.49848 10.4475C5.24059 10.7803 4.98651 10.8838 4.73275 10.9651Z",
  fill: "url(#paint26_radial_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.73275 10.9651C4.70221 11.0062 4.76656 11.0733 4.8868 11.147C4.90225 11.1564 4.92046 11.1685 4.9418 11.1825C5.11642 11.2977 5.50009 11.5509 6.28712 11.6732C7.17032 11.8105 7.19778 12.227 7.15202 12.7349C7.14162 12.8503 7.12344 12.9935 7.10362 13.1496C7.03622 13.6805 6.95002 14.3594 7.08795 14.5928C7.2321 14.8368 7.34341 14.6598 7.41464 14.5466C7.43161 14.5196 7.4463 14.4962 7.45862 14.483C7.52269 14.4144 7.64167 14.3274 7.83387 14.5288C8.02607 14.7301 8.31437 14.9589 8.66674 14.9589C9.01911 14.9589 9.33029 14.7118 9.52249 14.483C9.67854 14.2972 9.74409 14.3709 9.82691 14.464C9.84609 14.4855 9.8662 14.5081 9.88858 14.5288C9.90235 14.5415 9.91789 14.5567 9.93523 14.5737C10.0678 14.7035 10.3053 14.9361 10.6574 14.9361C11.0555 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.7419 14.3595 11.8563 14.483L11.8591 14.4861C12.0823 14.732 12.2882 14.9589 12.6938 14.9589C13.1011 14.9589 13.307 14.7393 13.5312 14.483C13.652 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.9269 14.5282 13.9486 14.5507C14.1544 14.7639 14.3428 14.9589 14.7422 14.9589C15.163 14.9589 15.4134 14.7313 15.5442 14.6124C15.5506 14.6065 15.5567 14.601 15.5625 14.5957C15.6875 14.483 15.7461 14.416 15.5625 14.2832C15.5478 14.2726 15.5286 14.2601 15.5058 14.2452C15.2446 14.0753 14.5078 13.5958 14.5078 11.9863V11.252C14.5078 11.0523 14.4896 10.9984 14.4152 10.9183C14.2177 10.8386 13.9975 10.646 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4856 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9024 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85548 10.4707C9.73634 10.3516 9.65626 10.3262 9.52736 10.4475C9.50635 10.4673 9.48245 10.4936 9.45502 10.5238L9.45501 10.5238C9.31406 10.6789 9.07998 10.9366 8.66798 10.9366C8.22195 10.9366 7.9684 10.6182 7.86081 10.483C7.84967 10.4691 7.8401 10.457 7.83204 10.4475C7.82372 10.4377 7.81555 10.4276 7.80743 10.4176C7.73165 10.3239 7.66029 10.2356 7.51564 10.4475C7.35548 10.6822 7.03907 10.9366 6.63052 10.9366C6.18653 10.9366 6.01271 10.7032 5.88411 10.5305C5.86176 10.5005 5.84078 10.4723 5.81998 10.4475C5.70225 10.3072 5.60263 10.3117 5.49848 10.4475C5.24059 10.7803 4.98651 10.8838 4.73275 10.9651Z",
  fill: "url(#paint27_radial_18_3868)"
}));

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.73275 10.9651C4.70221 11.0062 4.76656 11.0733 4.8868 11.147C4.90225 11.1564 4.92046 11.1685 4.9418 11.1825C5.11642 11.2977 5.50009 11.5509 6.28712 11.6732C7.17032 11.8105 7.19778 12.227 7.15202 12.7349C7.14162 12.8503 7.12344 12.9935 7.10362 13.1496C7.03622 13.6805 6.95002 14.3594 7.08795 14.5928C7.2321 14.8368 7.34341 14.6598 7.41464 14.5466C7.43161 14.5196 7.4463 14.4962 7.45862 14.483C7.52269 14.4144 7.64167 14.3274 7.83387 14.5288C8.02607 14.7301 8.31437 14.9589 8.66674 14.9589C9.01911 14.9589 9.33029 14.7118 9.52249 14.483C9.67854 14.2972 9.74409 14.3709 9.82691 14.464C9.84609 14.4855 9.8662 14.5081 9.88858 14.5288C9.90235 14.5415 9.91789 14.5567 9.93523 14.5737C10.0678 14.7035 10.3053 14.9361 10.6574 14.9361C11.0555 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.7419 14.3595 11.8563 14.483L11.8591 14.4861C12.0823 14.732 12.2882 14.9589 12.6938 14.9589C13.1011 14.9589 13.307 14.7393 13.5312 14.483C13.652 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.9269 14.5282 13.9486 14.5507C14.1544 14.7639 14.3428 14.9589 14.7422 14.9589C15.163 14.9589 15.4134 14.7313 15.5442 14.6124C15.5506 14.6065 15.5567 14.601 15.5625 14.5957C15.6875 14.483 15.7461 14.416 15.5625 14.2832C15.5478 14.2726 15.5286 14.2601 15.5058 14.2452C15.2446 14.0753 14.5078 13.5958 14.5078 11.9863V11.252C14.5078 11.0523 14.4896 10.9984 14.4152 10.9183C14.2177 10.8386 13.9975 10.646 13.8945 10.5098C13.7617 10.334 13.6094 10.3692 13.5039 10.5098C13.4949 10.5218 13.4856 10.5348 13.4756 10.5487C13.3691 10.697 13.1979 10.9356 12.7227 10.9356C12.24 10.9356 12.0675 10.7299 11.9327 10.5692C11.9224 10.5569 11.9123 10.5449 11.9024 10.5332C11.7617 10.3692 11.6211 10.3574 11.4844 10.5098C10.9336 11.0762 10.2891 10.9785 9.85548 10.4707C9.73634 10.3516 9.65626 10.3262 9.52736 10.4475C9.50635 10.4673 9.48245 10.4936 9.45502 10.5238L9.45501 10.5238C9.31406 10.6789 9.07998 10.9366 8.66798 10.9366C8.22195 10.9366 7.9684 10.6182 7.86081 10.483C7.84967 10.4691 7.8401 10.457 7.83204 10.4475C7.82372 10.4377 7.81555 10.4276 7.80743 10.4176C7.73165 10.3239 7.66029 10.2356 7.51564 10.4475C7.35548 10.6822 7.03907 10.9366 6.63052 10.9366C6.18653 10.9366 6.01271 10.7032 5.88411 10.5305C5.86176 10.5005 5.84078 10.4723 5.81998 10.4475C5.70225 10.3072 5.60263 10.3117 5.49848 10.4475C5.24059 10.7803 4.98651 10.8838 4.73275 10.9651Z",
  fill: "url(#paint28_radial_18_3868)"
});

var _ref26 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_ii_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "#E33E4A"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "url(#paint29_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "url(#paint30_radial_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "url(#paint31_radial_18_3868)"
}));

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "url(#paint32_radial_18_3868)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "url(#paint33_radial_18_3868)"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.34295 14.6491C7.3701 14.6174 7.39407 14.5793 7.41468 14.5466L7.41469 14.5466C7.43165 14.5196 7.44634 14.4962 7.45866 14.483C7.52273 14.4144 7.64171 14.3274 7.83391 14.5288C8.02611 14.7301 8.31441 14.959 8.66678 14.959C9.01915 14.959 9.33033 14.7118 9.52253 14.483C9.67858 14.2973 9.74413 14.3709 9.82695 14.464C9.84613 14.4855 9.86624 14.5081 9.88862 14.5288C9.90239 14.5415 9.91792 14.5567 9.93526 14.5737L9.93527 14.5737C10.0678 14.7035 10.3054 14.9361 10.6574 14.9361C11.0556 14.9361 11.3118 14.7393 11.5223 14.483C11.6186 14.3658 11.742 14.3595 11.8564 14.483L11.8592 14.4861C12.0823 14.732 12.2882 14.959 12.6938 14.959C13.1011 14.959 13.307 14.7393 13.5313 14.483C13.6521 14.345 13.7539 14.3457 13.8828 14.483C13.9051 14.5056 13.927 14.5282 13.9486 14.5506L13.9486 14.5507C14.1545 14.7639 14.3428 14.959 14.7422 14.959C15.1569 14.959 15.4061 14.7379 15.5384 14.6177C15.5894 14.6369 15.6414 14.6737 15.7109 14.723C15.7593 14.7573 15.8161 14.7975 15.8869 14.8421C15.9307 14.8669 15.974 14.8921 16.0175 14.9173C16.4175 15.1497 16.8286 15.3886 17.6743 15.3886H20.6374C22.9454 15.3886 23.9627 16.3436 24.5976 17.2403C24.7284 17.425 24.8362 17.6039 24.9388 17.7741C25.0584 17.9728 25.171 18.1597 25.3047 18.3301C25.3474 18.3846 25.3913 18.4337 25.4316 18.4786C25.5269 18.5851 25.6015 18.6684 25.5895 18.7448C25.5683 18.8803 25.3634 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9952 18.562 23.9821 18.5444 23.9698 18.5294C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5384 23.5658 18.5595C23.4246 18.707 23.1572 18.9864 22.7769 18.9864C22.342 18.9864 22.0787 18.673 21.9471 18.5054C21.8154 18.3379 21.6957 18.4137 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9864 20.7941 18.9864C20.3193 18.9864 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3778 19.5852 18.5054C19.4935 18.6331 19.2222 18.9864 18.7434 18.9864C18.3386 18.9864 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3778 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9864 16.7367 18.9864C16.2836 18.9864 15.9846 18.6422 15.8945 18.5385C15.8918 18.5354 15.8892 18.5325 15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9864 14.682 18.9864C14.3114 18.9864 14.048 18.7119 13.9188 18.5772C13.9005 18.5583 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3778 13.533 18.5298C13.5174 18.5455 13.5008 18.5628 13.4832 18.5812C13.3298 18.7414 13.0952 18.9864 12.6873 18.9864C12.2868 18.9864 12.0689 18.7496 11.9217 18.5899C11.9017 18.5681 11.8831 18.5479 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9864 10.6925 18.9864C10.2394 18.9864 9.99703 18.7045 9.86488 18.5509C9.85857 18.5435 9.85251 18.5365 9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.4623 18.5692C9.31695 18.7189 9.05724 18.9864 8.66692 18.9864C8.23921 18.9864 8.04675 18.7793 7.81864 18.5298C7.62837 18.3217 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581C7.39252 18.6646 7.38687 18.6715 7.38111 18.6784C7.30547 18.77 7.21179 18.8833 7.1058 18.6581C6.99175 18.4157 6.97036 18.0593 7.0559 17.6316C7.07853 17.5185 7.10066 17.4352 7.12097 17.3589C7.17744 17.1465 7.21986 16.987 7.21986 16.3841V15.4075C7.21986 15.3609 7.21954 15.3191 7.21926 15.2811C7.21721 15.0085 7.21661 14.928 7.34295 14.6491Z",
  fill: "url(#paint34_radial_18_3868)"
});

var _ref30 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_iii_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.30452 18.7601C7.22492 18.9522 7.22492 19.1178 7.22492 19.4033V20.8576C7.22492 21.132 7.16339 21.3708 7.1047 21.5987C7.05117 21.8065 7 22.0051 7 22.2132C7 22.5376 7.08874 22.6235 7.17225 22.7043C7.19037 22.7219 7.20825 22.7392 7.22492 22.7586C7.24102 22.7685 7.25435 22.7774 7.26571 22.785C7.32026 22.8215 7.32915 22.8274 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688C9.51368 22.559 9.5225 22.5496 9.53105 22.5405C9.63693 22.4278 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3982 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913C17.5416 22.5837 17.5481 22.5761 17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.584 17.9513 22.5997 17.966 22.6155C18.1497 22.8127 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8067 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.293 23.0137 25.4609 22.9356 25.5938 22.8731C25.7266 22.8106 25.6875 22.7129 25.5938 22.584C25.5 22.4551 25.3711 22.2285 25.3711 21.8145C25.3711 21.6747 25.3764 21.4411 25.3826 21.171C25.3947 20.6407 25.4101 19.9697 25.3945 19.5918C25.3845 19.3473 25.3651 19.1596 25.3084 18.9734C25.2171 19 25.1034 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9953 18.5621 23.9821 18.5443 23.9698 18.5293C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5383 23.5658 18.5595C23.4246 18.707 23.1572 18.9863 22.7769 18.9863C22.342 18.9863 22.0787 18.673 21.9471 18.5054C21.8154 18.3378 21.6957 18.4136 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9863 20.7941 18.9863C20.3193 18.9863 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3777 19.5852 18.5054C19.4935 18.6331 19.2222 18.9863 18.7434 18.9863C18.3386 18.9863 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3777 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9863 16.7367 18.9863C16.2836 18.9863 15.9846 18.6422 15.8945 18.5385L15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9863 14.682 18.9863C14.3114 18.9863 14.048 18.7119 13.9188 18.5772C13.9005 18.5582 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3777 13.5331 18.5298C13.5174 18.5454 13.5008 18.5627 13.4832 18.5812C13.3298 18.7414 13.0952 18.9863 12.6873 18.9863C12.2868 18.9863 12.0689 18.7496 11.9217 18.5898C11.9017 18.5681 11.8831 18.5478 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9863 10.6925 18.9863C10.2394 18.9863 9.99703 18.7045 9.86489 18.5509L9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.46231 18.5692C9.31695 18.7189 9.05724 18.9863 8.66692 18.9863C8.23922 18.9863 8.04675 18.7793 7.81864 18.5298C7.62837 18.3216 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581L7.38111 18.6784C7.35731 18.7072 7.33172 18.7382 7.30452 18.7601Z",
  fill: "#DE6FCF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.30452 18.7601C7.22492 18.9522 7.22492 19.1178 7.22492 19.4033V20.8576C7.22492 21.132 7.16339 21.3708 7.1047 21.5987C7.05117 21.8065 7 22.0051 7 22.2132C7 22.5376 7.08874 22.6235 7.17225 22.7043C7.19037 22.7219 7.20825 22.7392 7.22492 22.7586C7.24102 22.7685 7.25435 22.7774 7.26571 22.785C7.32026 22.8215 7.32915 22.8274 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688C9.51368 22.559 9.5225 22.5496 9.53105 22.5405C9.63693 22.4278 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3982 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913C17.5416 22.5837 17.5481 22.5761 17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.584 17.9513 22.5997 17.966 22.6155C18.1497 22.8127 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8067 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.293 23.0137 25.4609 22.9356 25.5938 22.8731C25.7266 22.8106 25.6875 22.7129 25.5938 22.584C25.5 22.4551 25.3711 22.2285 25.3711 21.8145C25.3711 21.6747 25.3764 21.4411 25.3826 21.171C25.3947 20.6407 25.4101 19.9697 25.3945 19.5918C25.3845 19.3473 25.3651 19.1596 25.3084 18.9734C25.2171 19 25.1034 19.0161 24.9672 19.0161C24.3321 19.0161 24.1261 18.7384 24.0097 18.5816C23.9953 18.5621 23.9821 18.5443 23.9698 18.5293C23.8581 18.3937 23.7384 18.3897 23.6187 18.5054C23.6037 18.5199 23.586 18.5383 23.5658 18.5595C23.4246 18.707 23.1572 18.9863 22.7769 18.9863C22.342 18.9863 22.0787 18.673 21.9471 18.5054C21.8154 18.3378 21.6957 18.4136 21.6079 18.5054C21.5962 18.5177 21.5816 18.5352 21.5639 18.5564C21.4491 18.6941 21.2055 18.9863 20.7941 18.9863C20.3193 18.9863 20.068 18.7009 19.9164 18.5054C19.7648 18.3099 19.677 18.3777 19.5852 18.5054C19.4935 18.6331 19.2222 18.9863 18.7434 18.9863C18.3386 18.9863 18.1307 18.7595 17.9892 18.6052C17.9634 18.577 17.9398 18.5513 17.9176 18.5298C17.774 18.3905 17.7181 18.3777 17.5705 18.5298C17.5535 18.5472 17.5356 18.5667 17.5165 18.5875C17.3692 18.7477 17.1498 18.9863 16.7367 18.9863C16.2836 18.9863 15.9846 18.6422 15.8945 18.5385L15.8869 18.5298C15.8071 18.4384 15.7193 18.3458 15.5518 18.5298C15.3842 18.7137 15.1049 18.9863 14.682 18.9863C14.3114 18.9863 14.048 18.7119 13.9188 18.5772C13.9005 18.5582 13.885 18.542 13.8722 18.5298C13.7684 18.4304 13.6847 18.3777 13.5331 18.5298C13.5174 18.5454 13.5008 18.5627 13.4832 18.5812C13.3298 18.7414 13.0952 18.9863 12.6873 18.9863C12.2868 18.9863 12.0689 18.7496 11.9217 18.5898C11.9017 18.5681 11.8831 18.5478 11.8654 18.5298C11.7178 18.3786 11.634 18.4017 11.5223 18.5298C11.5144 18.5388 11.5059 18.5489 11.4966 18.5597C11.375 18.7026 11.1337 18.9863 10.6925 18.9863C10.2394 18.9863 9.99703 18.7045 9.86489 18.5509L9.84669 18.5298C9.71902 18.3826 9.63638 18.3943 9.50094 18.5298C9.4891 18.5416 9.47623 18.5549 9.46231 18.5692C9.31695 18.7189 9.05724 18.9863 8.66692 18.9863C8.23922 18.9863 8.04675 18.7793 7.81864 18.5298C7.62837 18.3216 7.51745 18.4855 7.44038 18.5994C7.42506 18.622 7.41107 18.6427 7.39807 18.6581L7.38111 18.6784C7.35731 18.7072 7.33172 18.7382 7.30452 18.7601Z",
  fill: "url(#paint35_radial_18_3868)"
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_ii_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.30637 22.8089C7.33007 22.8178 7.34537 22.8058 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688L9.53105 22.5405C9.63693 22.4277 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3981 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913L17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.5839 17.9512 22.5996 17.9658 22.6154C18.1495 22.8126 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8066 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.0551 23.0137 25.2228 22.9928 25.3439 22.9641C25.3608 23.0458 25.3695 23.135 25.3695 23.2371V25.367C25.3695 25.8934 25.5242 26.3013 25.6016 26.4395C25.7712 26.7074 25.7192 26.838 25.4727 26.9356C25.3274 26.9931 25.0977 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.6134 27.0393 20.5331 26.9543 20.5331 26.7134V24.928C20.5331 24.0919 20.2214 23.834 19.3617 23.834H13C12.0469 23.834 12 24.4942 12 24.9473V26.4121C12 26.5488 12 26.6973 11.875 26.5879C11.75 26.4785 11.6992 26.4707 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8483 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4877 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67188 26.3731 7.5625 26.4551 7.47656 26.6113C7.39062 26.7676 7.28906 26.834 7.16797 26.6778C7.04688 26.5215 7 26.2481 7 25.9863C7 25.8105 7.03803 25.6496 7.08292 25.4597C7.14757 25.1862 7.22643 24.8526 7.22643 24.3274V23.3241C7.22643 23.0613 7.26914 22.8948 7.30637 22.8089Z",
  fill: "#4385F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.30637 22.8089C7.33007 22.8178 7.34537 22.8058 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688L9.53105 22.5405C9.63693 22.4277 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3981 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913L17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.5839 17.9512 22.5996 17.9658 22.6154C18.1495 22.8126 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8066 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.0551 23.0137 25.2228 22.9928 25.3439 22.9641C25.3608 23.0458 25.3695 23.135 25.3695 23.2371V25.367C25.3695 25.8934 25.5242 26.3013 25.6016 26.4395C25.7712 26.7074 25.7192 26.838 25.4727 26.9356C25.3274 26.9931 25.0977 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.6134 27.0393 20.5331 26.9543 20.5331 26.7134V24.928C20.5331 24.0919 20.2214 23.834 19.3617 23.834H13C12.0469 23.834 12 24.4942 12 24.9473V26.4121C12 26.5488 12 26.6973 11.875 26.5879C11.75 26.4785 11.6992 26.4707 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8483 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4877 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67188 26.3731 7.5625 26.4551 7.47656 26.6113C7.39062 26.7676 7.28906 26.834 7.16797 26.6778C7.04688 26.5215 7 26.2481 7 25.9863C7 25.8105 7.03803 25.6496 7.08292 25.4597C7.14757 25.1862 7.22643 24.8526 7.22643 24.3274V23.3241C7.22643 23.0613 7.26914 22.8948 7.30637 22.8089Z",
  fill: "url(#paint36_radial_18_3868)"
}));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M7.30637 22.8089C7.33007 22.8178 7.34537 22.8058 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688L9.53105 22.5405C9.63693 22.4277 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3981 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913L17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.5839 17.9512 22.5996 17.9658 22.6154C18.1495 22.8126 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8066 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.0551 23.0137 25.2228 22.9928 25.3439 22.9641C25.3608 23.0458 25.3695 23.135 25.3695 23.2371V25.367C25.3695 25.8934 25.5242 26.3013 25.6016 26.4395C25.7712 26.7074 25.7192 26.838 25.4727 26.9356C25.3274 26.9931 25.0977 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.6134 27.0393 20.5331 26.9543 20.5331 26.7134V24.928C20.5331 24.0919 20.2214 23.834 19.3617 23.834H13C12.0469 23.834 12 24.4942 12 24.9473V26.4121C12 26.5488 12 26.6973 11.875 26.5879C11.75 26.4785 11.6992 26.4707 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8483 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4877 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67188 26.3731 7.5625 26.4551 7.47656 26.6113C7.39062 26.7676 7.28906 26.834 7.16797 26.6778C7.04688 26.5215 7 26.2481 7 25.9863C7 25.8105 7.03803 25.6496 7.08292 25.4597C7.14757 25.1862 7.22643 24.8526 7.22643 24.3274V23.3241C7.22643 23.0613 7.26914 22.8948 7.30637 22.8089Z",
  fill: "url(#paint37_linear_18_3868)"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M7.30637 22.8089C7.33007 22.8178 7.34537 22.8058 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688L9.53105 22.5405C9.63693 22.4277 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3981 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913L17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.5839 17.9512 22.5996 17.9658 22.6154C18.1495 22.8126 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8066 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.0551 23.0137 25.2228 22.9928 25.3439 22.9641C25.3608 23.0458 25.3695 23.135 25.3695 23.2371V25.367C25.3695 25.8934 25.5242 26.3013 25.6016 26.4395C25.7712 26.7074 25.7192 26.838 25.4727 26.9356C25.3274 26.9931 25.0977 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.6134 27.0393 20.5331 26.9543 20.5331 26.7134V24.928C20.5331 24.0919 20.2214 23.834 19.3617 23.834H13C12.0469 23.834 12 24.4942 12 24.9473V26.4121C12 26.5488 12 26.6973 11.875 26.5879C11.75 26.4785 11.6992 26.4707 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8483 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4877 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67188 26.3731 7.5625 26.4551 7.47656 26.6113C7.39062 26.7676 7.28906 26.834 7.16797 26.6778C7.04688 26.5215 7 26.2481 7 25.9863C7 25.8105 7.03803 25.6496 7.08292 25.4597C7.14757 25.1862 7.22643 24.8526 7.22643 24.3274V23.3241C7.22643 23.0613 7.26914 22.8948 7.30637 22.8089Z",
  fill: "url(#paint38_radial_18_3868)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M7.30637 22.8089C7.33007 22.8178 7.34537 22.8058 7.38074 22.7586C7.42432 22.7005 7.43997 22.6729 7.46853 22.6224C7.48081 22.6007 7.49548 22.5748 7.51578 22.5405C7.5833 22.4262 7.69238 22.4054 7.82742 22.5405C7.84671 22.5597 7.8679 22.5832 7.8914 22.6091C8.0325 22.765 8.25701 23.0131 8.65327 23.0131C9.09098 23.0131 9.34241 22.743 9.50458 22.5688L9.53105 22.5405C9.63693 22.4277 9.76478 22.447 9.84788 22.5405C10.0234 22.7586 10.293 22.9863 10.6914 22.9863C11.0898 22.9863 11.3359 22.7665 11.5312 22.5405C11.6759 22.3731 11.7734 22.4551 11.8906 22.5801L11.8925 22.5821C12.118 22.8232 12.2707 22.9863 12.6719 22.9863C13.0742 22.9863 13.2891 22.8211 13.5391 22.5405C13.6583 22.4066 13.7188 22.3993 13.8477 22.5405C14.1688 22.8922 14.2852 22.9863 14.6719 22.9863C15.0117 22.9863 15.2461 22.9434 15.5586 22.5405C15.669 22.3981 15.7539 22.3926 15.8711 22.5405C16.0625 22.791 16.2383 23.0137 16.7148 23.0137C17.176 23.0137 17.3409 22.8198 17.5352 22.5913L17.5547 22.5684C17.6883 22.4116 17.7461 22.3731 17.9219 22.5684C17.9366 22.5839 17.9512 22.5996 17.9658 22.6154C18.1495 22.8126 18.3368 23.0137 18.7383 23.0137C19.166 23.0137 19.377 22.7856 19.5701 22.577L19.5781 22.5684C19.7284 22.406 19.8008 22.4199 19.9336 22.5684C20.1055 22.7871 20.4141 23.0137 20.8359 23.0137C21.2578 23.0137 21.5039 22.6895 21.6484 22.4981C21.7327 22.3865 21.8125 22.3809 21.8984 22.4981C22.0664 22.7481 22.3438 23.0137 22.7461 23.0137C23.1484 23.0137 23.4141 22.8066 23.6445 22.5176C23.707 22.4395 23.8281 22.4043 23.9336 22.5176C23.9453 22.5301 23.9589 22.5459 23.9747 22.5642C24.1014 22.7108 24.363 23.0137 24.8008 23.0137C25.0551 23.0137 25.2228 22.9928 25.3439 22.9641C25.3608 23.0458 25.3695 23.135 25.3695 23.2371V25.367C25.3695 25.8934 25.5242 26.3013 25.6016 26.4395C25.7712 26.7074 25.7192 26.838 25.4727 26.9356C25.3274 26.9931 25.0977 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.6134 27.0393 20.5331 26.9543 20.5331 26.7134V24.928C20.5331 24.0919 20.2214 23.834 19.3617 23.834H13C12.0469 23.834 12 24.4942 12 24.9473V26.4121C12 26.5488 12 26.6973 11.875 26.5879C11.75 26.4785 11.6992 26.4707 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8483 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4877 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67188 26.3731 7.5625 26.4551 7.47656 26.6113C7.39062 26.7676 7.28906 26.834 7.16797 26.6778C7.04688 26.5215 7 26.2481 7 25.9863C7 25.8105 7.03803 25.6496 7.08292 25.4597C7.14757 25.1862 7.22643 24.8526 7.22643 24.3274V23.3241C7.22643 23.0613 7.26914 22.8948 7.30637 22.8089Z",
  fill: "url(#paint39_radial_18_3868)"
});

var _ref35 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_i_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "#7350AD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "url(#paint40_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "url(#paint41_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "url(#paint42_radial_18_3868)"
}));

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "url(#paint43_linear_18_3868)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "url(#paint44_linear_18_3868)"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7151 27.0321C20.5534 27.0475 20.5534 27.1746 20.5535 27.4336C20.5535 27.4396 20.5535 27.4456 20.5535 27.4517V28.6538C20.5535 29.4259 20.9966 29.926 21.8433 29.926H24.2167C25.2213 29.926 25.41 29.1539 25.41 28.7503V27.2762C25.41 27.1082 25.3986 27.0359 25.3602 26.9774C25.2211 27.0252 25.0412 27.0723 24.8516 27.0723C24.3004 27.0723 24.1152 26.8059 24.0057 26.6483C23.9832 26.616 23.9639 26.5883 23.9453 26.5684C23.8359 26.4512 23.7148 26.4863 23.6562 26.5684C23.4141 26.916 23.1406 27.0393 22.8008 27.0393C22.4609 27.0393 22.207 26.9199 21.957 26.6048C21.7969 26.416 21.734 26.4248 21.5959 26.6048C21.2841 27.011 20.9818 27.0393 20.7976 27.0393C20.7673 27.0393 20.7399 27.037 20.7151 27.0321Z",
  fill: "url(#paint45_radial_18_3868)"
});

var _ref39 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_i_18_3868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "#7350AD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "url(#paint46_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "url(#paint47_linear_18_3868)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "url(#paint48_radial_18_3868)"
}));

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "url(#paint49_linear_18_3868)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "url(#paint50_linear_18_3868)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M7.34481 26.7583C7.23127 26.9443 7.23146 27.0624 7.23175 27.2423C7.23176 27.2515 7.23178 27.2609 7.23178 27.2704V28.6287C7.23178 29.2697 7.65069 29.9108 8.30444 29.9108H10.9448C11.6684 29.9108 12 29.3332 12 28.7556V27.1117C12 26.8134 11.9477 26.6674 11.7763 26.5214C11.7742 26.5196 11.7721 26.5178 11.77 26.516C11.7033 26.4915 11.6398 26.5238 11.5156 26.6348C11.4968 26.6516 11.4776 26.6694 11.4577 26.6877C11.2839 26.8482 11.0625 27.0528 10.6523 27.0528C10.2381 27.0528 10.0453 26.8281 9.91679 26.6784C9.90354 26.663 9.89097 26.6483 9.87891 26.6348L9.87387 26.6291C9.74783 26.4878 9.66557 26.3955 9.48438 26.6113C9.30078 26.8301 9.11328 27.0528 8.64844 27.0528C8.18359 27.0528 7.95312 26.7637 7.8125 26.5684C7.67187 26.3731 7.5625 26.4551 7.47656 26.6113C7.43622 26.6847 7.39244 26.7382 7.34481 26.7583Z",
  fill: "url(#paint51_radial_18_3868)"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.51796,
  cy: 8.15851,
  r: 0.579299,
  fill: "url(#paint52_radial_18_3868)"
});

var _ref44 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.51796,
  cy: 8.15851,
  r: 0.579299,
  fill: "url(#paint53_radial_18_3868)"
});

var _ref45 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.51796,
  cy: 8.15851,
  r: 0.579299,
  fill: "url(#paint54_radial_18_3868)"
});

var _ref46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_18_3868",
  x: 23.6807,
  y: 16.5124,
  width: 4.84948,
  height: 8.00767,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.505882 0 0 0 0 0.482353 0 0 0 0 0.698039 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_i_18_3868",
  x: 10,
  y: 2.07399,
  width: 2.72089,
  height: 3.97808,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.619608 0 0 0 0 0.729412 0 0 0 0 0.560784 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_ii_18_3868",
  x: 7.91797,
  y: 1.97399,
  width: 7.08727,
  height: 5.06587,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.6 0 0 0 0 0.701961 0 0 0 0 0.211765 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.647059 0 0 0 0 0.772549 0 0 0 0 0.454902 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_3868",
  result: "effect2_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_ii_18_3868",
  x: 3.61023,
  y: 6.33083,
  width: 11.3034,
  height: 4.78913,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.898039 0 0 0 0 0.588235 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.941176 0 0 0 0 0.764706 0 0 0 0 0.0980392 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_3868",
  result: "effect2_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_ii_18_3868",
  x: 4.72525,
  y: 10.2169,
  width: 11.054,
  height: 4.84201,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.933333 0 0 0 0 0.4 0 0 0 0 0.129412 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 0.521569 0 0 0 0 0.129412 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_3868",
  result: "effect2_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_ii_18_3868",
  x: 7.00363,
  y: 14.218,
  width: 18.5872,
  height: 4.89812,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.862745 0 0 0 0 0.156863 0 0 0 0 0.0941176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.15
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.862745 0 0 0 0 0.156863 0 0 0 0 0.0941176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_3868",
  result: "effect2_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_iii_18_3868",
  x: 7,
  y: 18.2829,
  width: 18.7793,
  height: 4.83077,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1,
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.92549 0 0 0 0 0.662745 0 0 0 0 0.823529 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.905882 0 0 0 0 0.4 0 0 0 0 0.733333 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_3868",
  result: "effect2_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.776471 0 0 0 0 0.34902 0 0 0 0 0.776471 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_innerShadow_18_3868",
  result: "effect3_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_ii_18_3868",
  x: 7,
  y: 22.3122,
  width: 18.7005,
  height: 4.86003,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.258824 0 0 0 0 0.411765 0 0 0 0 0.921569 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.258824 0 0 0 0 0.411765 0 0 0 0 0.921569 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow_18_3868",
  result: "effect2_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_i_18_3868",
  x: 20.5535,
  y: 26.4665,
  width: 4.85648,
  height: 3.55954,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.247059 0 0 0 0 0.239216 0 0 0 0 0.580392 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_i_18_3868",
  x: 7.23172,
  y: 26.454,
  width: 4.76828,
  height: 3.55679,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.247059 0 0 0 0 0.239216 0 0 0 0 0.580392 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_18_3868"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_18_3868",
  x1: 23.5694,
  y1: 15.6741,
  x2: 27.1414,
  y2: 15.0614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F87533"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF953D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.456 16.0332) rotate(-51.5463) scale(2.03515 0.420097)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FA9468"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FA9468",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.0185 16.8613) rotate(-62.3789) scale(3.03318 4.32601)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA153"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA153",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_18_3868",
  x1: 24.1435,
  y1: 16.6113,
  x2: 29.456,
  y2: 18.2363,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E43446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F95572"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(27.2373 16.8926) rotate(124.992) scale(1.52582 1.72394)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF728D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF728D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.9873 16.6426) rotate(-51.7536) scale(1.69111 0.59319)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F26D69"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F26D69",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.4302 17.9592) rotate(139.77) scale(2.6968 3.12095)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#71CDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71CDFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(29.2067 21.2402) rotate(150.068) scale(4.62723 9.44196)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.605862,
  stopColor: "#1C81FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.878161,
  stopColor: "#1C81FF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.4302 24.7642) rotate(-114.45) scale(4.09363 1.22982)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.23189,
  stopColor: "#71CDFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71CDFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.2373 28.5176) rotate(-90) scale(5.4375 1.76449)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15894,
  stopColor: "#574774"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#574774",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.1435 29.9108) rotate(-90) scale(2.7057 3.6875)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#592C84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#592C84",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_18_3868",
  x1: 11.8154,
  y1: 30.0332,
  x2: 11.8154,
  y2: 29.627,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9360C1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9360C1",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.0119 28.5717) rotate(-90) scale(4.9822 1.98478)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3A265E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3A265E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_18_3868",
  x1: 18.4981,
  y1: 26.1414,
  x2: 19.2018,
  y2: 26.1414,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#625F70"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#625F70",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.5384 29.9108) rotate(-90) scale(3.40484 5.13762)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D2C88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D2C88",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.5709 2.07399) rotate(139.994) scale(1.67818 1.43947)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#759F59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#759F59",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.1353 4.38236) rotate(-90) scale(1.79576 1.05157)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.243243,
  stopColor: "#2F7309"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2F7309",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_18_3868",
  x1: 9.36227,
  y1: 5.79883,
  x2: 14.8053,
  y2: 3.64258,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#90B139"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9FBF45"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint18_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.2998 3.11133) rotate(90) scale(4.625 1.46875)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B8D964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B8D964",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.8545 3.83789) rotate(50.0338) scale(1.07031 0.953964)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A8C874"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A8C874",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_18_3868",
  x1: 5.51852,
  y1: 10.1739,
  x2: 14.7136,
  y2: 10.1739,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6BB42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD456"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_18_3868",
  x1: 9.16191,
  y1: 11.02,
  x2: 9.16191,
  y2: 9.73768,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDCE51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FDCE51",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint22_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.45602 12.9239) rotate(-125.272) scale(7.8468 10.985)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.798573,
  stopColor: "#FFE18C",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.952974,
  stopColor: "#FFE18C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint23_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.36227 6.33083) rotate(40.0041) scale(3.30451 3.39349)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8D569"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8D569",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint24_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.2685 11.02) rotate(-90) scale(5.06485 1.78896)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE860"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE860",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_18_3868",
  x1: 7.64352,
  y1: 13.5488,
  x2: 13.6748,
  y2: 13.5488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EF6F44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8E50"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint26_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.081 12.2676) rotate(170.524) scale(2.24945 5.41745)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.166667,
  stopColor: "#FFA764"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFA764",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint27_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.39352 11.6738) rotate(-15.124) scale(3.59321 2.12641)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F06B8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F06B8A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint28_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.29977 13.0645) rotate(-46.017) scale(1.8675 0.9525)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.544369,
  stopColor: "#F89B83"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F89B83",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_18_3868",
  x1: 7.15652,
  y1: 15.9137,
  x2: 7.8845,
  y2: 15.9137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F18C8B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F18C8B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint30_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.206 19.8613) rotate(-104.534) scale(4.35823 9.87798)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6165"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6165",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint31_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.4248 14.368) rotate(122.839) scale(2.76609 4.76663)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6165"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6165",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint32_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.331 15.4238) rotate(92.3859) scale(0.750651 7.2216)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E95852"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E95852",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint33_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.081 14.8926) rotate(120.7) scale(1.16299 1.31246)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.302527,
  stopColor: "#FF6165"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF6165",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint34_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.581 16.2988) rotate(137.77) scale(2.74324 10.9699)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD605A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD605A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint35_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.0185 17.7363) rotate(90) scale(5.27734 7.15684)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8BE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8BE0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint36_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.1094 27.3336) rotate(-90) scale(4.92136 2.60542)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5D9BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5D9BFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear_18_3868",
  x1: 6.55302,
  y1: 26.309,
  x2: 7.55586,
  y2: 26.4398,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97BEF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#97BEF7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint38_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.3503 24.2379) rotate(-90) scale(2.7033 7.0548)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0645161,
  stopColor: "#7D68FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D68FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint39_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.1927 27.0723) rotate(-90) scale(5.10168 4.03855)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#64B8FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#64B8FF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint40_linear_18_3868",
  x1: 20.5535,
  y1: 29.1078,
  x2: 22.6551,
  y2: 29.1078,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#544387"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#544387",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear_18_3868",
  x1: 25.6292,
  y1: 29.1078,
  x2: 24.6759,
  y2: 29.1078,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#544387"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#544387",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint42_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.0659 26.7713) rotate(90) scale(2.0967 1.08412)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.258064,
  stopColor: "#775EAB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#775EAB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint43_linear_18_3868",
  x1: 20.5535,
  y1: 28.1962,
  x2: 21.0536,
  y2: 28.1962,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#938AAE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#938AAE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint44_linear_18_3868",
  x1: 23.532,
  y1: 30.1329,
  x2: 23.532,
  y2: 28.7466,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7F41C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F41C9",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint45_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.5643 27.6873) rotate(39.2062) scale(3.26545 3.65386)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.883035,
  stopColor: "#9261CE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9261CE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint46_linear_18_3868",
  x1: 7.23172,
  y1: 29.1442,
  x2: 9.29512,
  y2: 29.1442,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#544387"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#544387",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint47_linear_18_3868",
  x1: 12.2152,
  y1: 29.1442,
  x2: 11.2793,
  y2: 29.1442,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#544387"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#544387",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint48_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.6803 26.9551) rotate(90) scale(1.96445 1.06443)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.258064,
  stopColor: "#775EAB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#775EAB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint49_linear_18_3868",
  x1: 7.23172,
  y1: 28.1824,
  x2: 7.72276,
  y2: 28.1824,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#938AAE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#938AAE",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint50_linear_18_3868",
  x1: 10.1562,
  y1: 30.1175,
  x2: 10.1562,
  y2: 28.7324,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7F41C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7F41C9",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint51_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.20602 27.6738) rotate(39.6991) scale(3.22894 3.62521)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.883035,
  stopColor: "#9261CE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9261CE"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint52_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.7773 8.06368) rotate(145.061) scale(0.419291)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#796F84"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#443355"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint53_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.51796 8.54103) rotate(90) scale(0.390625)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A2E7B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5A2E7B",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint54_radial_18_3868",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(9.76852 8.53322) rotate(-130.83) scale(1.06348 1.29697)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.734244,
  stopColor: "#6E666F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6E666F"
})));

function SvgPiniata(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiniata);
export default __webpack_public_path__ + "static/media/piniata.c816ce82.svg";
export { ForwardRef as ReactComponent };